import './bar_chart_view.js.coffee';# Added by Script 
import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FansAgeDistributionView extends Monitoring.Reports.Executive.BarChartView 
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  tagName: 'section'
  chartClass: 'column-chart'
  icon: 'column'

  initialize: (@options = {}) ->
    @colors = @options.colors
    @target = { fans: @options.chartApi.fans_gender}

  _columnOptions: (response, divId) =>
    ages = {}
    for k,v of response
        if ages[k.substring(2)] then ages[k.substring(2)] += v else ages[k.substring(2)] = v
    hashSeries = {}
    hashSeries["Cantidad"] = [ages["13-17"] || 0, ages["18-24"] || 0, ages["25-34"] || 0, ages["35-44"] || 0, ages["45-54"] || 0, ages["55-64"] || 0, ages["65+"] || 0]

    series = _.map(hashSeries, (values, index) => { name: index, data: values, color: @colors[index.toLowerCase()] })
    serie.type = 'column' for serie in series
    categories = ["13 - 17", "18 - 24", "25 - 34", "35 - 44", "45 - 54","55 - 64", "65+"]

    @highchartsBarOptions(divId, series, categories)
